/**
 * 複数スタンプがある場合は現在日時が startAt〜endAt の範囲に入るスタンプを返す。
 * スタンプが1件の場合はそのまま返す（単一スタンプのスポットに startAt/endAt がない場合も対応）。
 * 該当するスタンプがない場合は null を返す。
 * ※ 選べるマークイズ暫定対応
 */
export function getActiveStamp<T extends { startAt?: string | null; endAt?: string | null }>(stamps: T[]): T | null {
  if (stamps.length === 0) return null
  if (stamps.length === 1) return stamps[0]

  const now = new Date()
  return (
    stamps.find((s) => {
      const startOk = s.startAt == null || now >= new Date(s.startAt)
      const endOk = s.endAt == null || now <= new Date(s.endAt)
      return startOk && endOk
    }) ?? null
  )
}
